import type {MarketPlaceAsk} from '@/types/MarketPlace';
import {MarketPlaceStatus} from '@/types/MarketPlace';

import {isExpired} from './date';

export const getAskStatusDisplay = (
  status: MarketPlaceStatus,
  expiresAt?: Date | string,
): {label: string; className: string} => {
  switch (status) {
    case MarketPlaceStatus.OPEN:
      return isExpired(expiresAt)
        ? {label: 'Expired', className: 'text-red-600'}
        : {label: 'Open', className: 'text-green-600'};
    case MarketPlaceStatus.PENDING_ADMIN_APPROVAL:
      return {label: 'Pending approval', className: 'text-yellow-600'};
    case MarketPlaceStatus.CLOSED:
      return {label: 'Closed', className: 'text-gray-500'};
    default:
      return {label: 'Closed', className: 'text-gray-500'};
  }
};

export const getAskStatusLabel = (ask: MarketPlaceAsk): string => {
  if (ask.meta?.flags?.isDeactivated) {
    return 'DISABLED';
  }
  if (ask.status === MarketPlaceStatus.PENDING_ADMIN_APPROVAL) {
    return 'PENDING APPROVAL';
  }
  if (ask.status === MarketPlaceStatus.OPEN && isExpired(ask.expiresAt)) {
    return 'EXPIRED';
  }
  return ask.status === MarketPlaceStatus.OPEN ? 'OPEN' : 'CLOSED';
};

export const getBidStatusDisplay = (
  status: MarketPlaceStatus,
  expiresAt?: Date | string,
  hasExpired?: boolean,
): {label: string; className: string} => {
  switch (status) {
    case MarketPlaceStatus.OPEN:
      return isExpired(expiresAt) || hasExpired
        ? {label: 'Expired', className: 'text-red-600'}
        : {label: 'Open', className: 'text-green-600'};
    case MarketPlaceStatus.PAID:
      return {label: 'Paid', className: 'text-green-600'};
    case MarketPlaceStatus.CLOSED:
      return {label: 'Closed', className: 'text-gray-500'};
    case MarketPlaceStatus.PENDING_ADMIN_APPROVAL:
      return {label: 'Pending approval', className: 'text-amber-600'};
    default:
      return {label: 'Closed', className: 'text-gray-500'};
  }
};
